import { Form, Switch } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import styles from '../Input/Input.module.scss';
import cn from 'classnames';

interface SwitchI {
  name: string;
  label?: string;
  defaultValue?: boolean;
}

const CustomSwitch = ({ label = '', name, defaultValue = false }: SwitchI) => {
  return (
    <div className={cn(styles.wrapper, { [styles.wrapper_withLabel]: label })}>
      <div>{label}:</div>
      <Form.Item name={name} valuePropName="checked">
        <Switch
          checkedChildren={<CheckOutlined />}
          unCheckedChildren={<CloseOutlined />}
          defaultChecked={defaultValue}
        />
      </Form.Item>
    </div>
  );
};

export default CustomSwitch;
